import { HrmsType } from "./hrmsTypes";

export const initialState: HrmsType = {
  success: null,
  error: null,
  statusCode: null,
  message: "",
  fetching: false,
  openPoisitionList: [],
  openPositionTotalCount: 0,
  recruitmentTrackerList:[],
  recruitmentTrackerTotalCount:0,
  singleRecruitmentTrackerList:[],
  uniqueCheckFetching:false,
  uniqueCheckMessage:"",
  addEditFetching: false,
  approvalList: [],
  approvalTotalCount:0,
  recruitmentTrackerStageCount:[],
  hrmsBulkUploadData: {},
  bulkUploadHistoryData: [],
  bulkUploadHistoryCount: 0,
};
